import { absoluteUrl } from '@constants/site';
import type { JsonLdDocument, JsonLdNode } from './types';
import { SCHEMA_CONTEXT } from './types';

export interface BreadcrumbSource {
  title?: string | null;
  url?: string | boolean | null;
  binding?: boolean | null;
}

interface Crumb {
  names: string[];
  url: string;
  binding: boolean;
}

const urlOf = (item: BreadcrumbSource): string =>
  typeof item.url === 'string' ? item.url.trim() : '';

export const buildBreadcrumbList = (
  items: ReadonlyArray<BreadcrumbSource> | null | undefined
): JsonLdDocument | null => {
  const crumbs: Crumb[] = [];
  (items ?? []).forEach(item => {
    const title = typeof item?.title === 'string' ? item.title.trim() : '';
    if (!title) {
      return;
    }
    const binding = item.binding === true;
    const previous = crumbs[crumbs.length - 1];
    if (binding && previous?.binding) {
      previous.names.push(title);
      if (!previous.url) {
        previous.url = urlOf(item);
      }
      return;
    }
    crumbs.push({ names: [title], url: urlOf(item), binding });
  });
  const linked = crumbs.filter(
    (crumb, index) => crumb.url !== '' || index === crumbs.length - 1
  );
  if (linked.length < 2) {
    return null;
  }
  const lastIndex = linked.length - 1;
  const itemListElement: JsonLdNode[] = linked.map((crumb, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: crumb.names.join(', '),
    item: index === lastIndex ? undefined : absoluteUrl(crumb.url)
  }));
  return {
    '@context': SCHEMA_CONTEXT,
    '@type': 'BreadcrumbList',
    itemListElement
  };
};
